import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Member from '../MenTeam/Member'
import Footer from '../Footer/Main'

function Main() {
    return (
        <>
            <Header />
            <main>
                <Breadcrumb mainheading={"Team"} sub={"Home"} title={"Team"} />
                <Member />
            </main>
            <Footer />

        </>
    )
}

export default Main